<template>  
  <div class="chat-panel" ref="chatPanelRef">
    <div class="chat-page">
      <div class="message-list" >
        <MessageList :messages="messages" :isWaitingForAIResponse="isWaitingForAIResponse"></MessageList>
      </div>
    </div>
    <div class="composer-wrapper m-2">
      <ChatComposer @submit="sendMessage" :isWaitingForAIResponse="isWaitingForAIResponse"></ChatComposer>
    </div>
  </div>
</template>
<script>
import { nextTick } from 'vue'
import MessageList from './MessageList.vue';
import ChatComposer from './ChatComposer.vue';

export default {
  name: 'ChatPanel',
  components: {
    MessageList,
    ChatComposer,
  },
  props: {
    // single message: id, role, text, createdAt
    messages: {
      type: Array,
      required: true,
    },
    isWaitingForAIResponse: {
      type: Boolean,
      required: true,
    },
  },
  emits: ['submit'],
  methods: {
    sendMessage(prompt) {
      this.$emit('submit', prompt);
    },
    async scrollDown(offset = null) {
      await nextTick();
      const el = this.$refs.chatPanelRef;
      if (!el) return;
      const targetTop = offset ? el.scrollTop + offset : el.scrollHeight;

      el.scrollTo({ top: targetTop, behavior: "auto", });
    },
  },
};
</script>

<style scoped>
.chat-panel {
  max-height: 92vh;
  overflow: auto;
  position: relative;
  display: flex;
  flex-direction: column;
  align-items: center;
}
.chat-page {
  margin-bottom: 12vh;
  width: 100%;
}
.message-list {}

.composer-wrapper {
  position: fixed;
  bottom: 0;
  width: 60vw;
}
</style>
